
import React from 'react';

const RubikVisual: React.FC = () => {
  return (
    <div className="relative w-full max-w-[500px] aspect-square flex items-center justify-center">
      <div className="relative w-full h-full overflow-hidden rounded-[2.5rem] glass border-white/10 shadow-2xl">
        <video 
          src="https://lqpglobal.com/animacion1.mp4?v=2.0"
          autoPlay 
          muted 
          playsInline
          className="w-full h-full object-cover transform scale-105"
        />
        {/* Overlay gradient to blend with the dark background */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent pointer-events-none" />
      </div>
      
      {/* Visual Accents */}
      <div className="absolute -top-6 -right-6 w-32 h-32 bg-red-500/10 blur-[60px] rounded-full animate-pulse" />
      <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-blue-500/10 blur-[80px] rounded-full animate-pulse" />
    </div>
  );
};

export default RubikVisual;